package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import se.mittpass.shared.api.*

class FoodSafetyRepository(private val httpClient: HttpClient) {
    suspend fun getTemplates(workplaceId: Long): Result<List<FoodSafetyTemplateDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/food-safety/templates").body()
    }
    suspend fun createTemplate(workplaceId: Long, req: CreateFoodSafetyTemplateRequest): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/food-safety/templates") { setBody(req) }
    }
    suspend fun updateTemplate(templateId: Long, req: UpdateFoodSafetyTemplateRequest): Result<Unit> = runCatching {
        httpClient.put("food-safety/templates/$templateId") { setBody(req) }
    }
    suspend fun deleteTemplate(templateId: Long): Result<Unit> = runCatching {
        httpClient.delete("food-safety/templates/$templateId")
    }
    suspend fun getToday(workplaceId: Long): Result<List<FoodSafetyTodayItemDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/food-safety/today").body()
    }
    suspend fun submitLog(workplaceId: Long, req: CreateFoodSafetyLogRequest): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/food-safety/log") { setBody(req) }
    }
    suspend fun getLogs(workplaceId: Long, from: String, to: String): Result<List<FoodSafetyLogDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/food-safety/logs") {
            parameter("from", from); parameter("to", to)
        }.body()
    }
    suspend fun getDeviations(workplaceId: Long): Result<List<FoodSafetyLogDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/food-safety/deviations").body()
    }
    suspend fun getReport(workplaceId: Long, from: String, to: String): Result<FoodSafetyReportDto> = runCatching {
        httpClient.get("workplaces/$workplaceId/food-safety/report") {
            parameter("from", from); parameter("to", to)
        }.body()
    }
}
